// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.layout__with_sidebar .sidebar {
  min-width: 0;
}
.layout__with_sidebar .main {
  width: 100vw;
  margin-top: 65px;
}
.layout__with_sidebar .custom_header {
  display: none;
}

@media (min-width: 778px) {
  .layout__with_sidebar {
    display: flex;
  }
  .layout__with_sidebar .sidebar {
    width: 350px;
    transition: width 0.3s;
  }
  .layout__with_sidebar .main {
    width: calc(100vw - 350px);
    height: 100vh;
    overflow-y: auto;
    margin-top: 0px;
  }
  .layout__with_sidebar .custom_header {
    display: flex;
  }
  .layout__with_sidebar .custom_header img {
    display: none;
    visibility: collapse;
  }
  .layout__with_sidebar .custom_header_avatar img {
    display: block;
    visibility: visible;
  }
  .layout__without_sidebar {
    display: flex;
  }
  .layout__without_sidebar .sidebar {
    width: 0;
    transition: width 0.3s;
    visibility: collapse;
  }
  .layout__without_sidebar .main {
    width: 100vw;
    height: 100vh;
    overflow-y: auto;
  }
}`, "",{"version":3,"sources":["webpack://./src/containers/Layout/style.scss"],"names":[],"mappings":"AAEQ;EACI,YAAA;AADZ;AAIQ;EACI,YAAA;EACA,gBAAA;AAFZ;AAKQ;EACI,aAAA;AAHZ;;AAQA;EAEQ;IACI,aAAA;EANV;EAQU;IACI,YAAA;IACA,sBAAA;EANd;EASU;IACI,0BAAA;IACA,aAAA;IACA,gBAAA;IACA,eAAA;EAPd;EAUU;IACI,aAAA;EARd;EAUc;IACI,aAAA;IACA,oBAAA;EARlB;EAYkB;IACI,cAAA;IACA,mBAAA;EAVtB;EAgBM;IACI,aAAA;EAdV;EAgBU;IACI,QAAA;IACA,sBAAA;IACA,oBAAA;EAdd;EAiBU;IACI,YAAA;IACA,aAAA;IACA,gBAAA;EAfd;AACF","sourcesContent":[".layout {\n    &__with_sidebar {\n        .sidebar {\n            min-width: 0;\n        }\n\n        .main {\n            width: 100vw;\n            margin-top: 65px;\n        }\n\n        .custom_header {\n            display: none;\n        }\n    }\n}\n\n@media (min-width: 778px) {\n    .layout {\n        &__with_sidebar {\n            display: flex;\n\n            .sidebar {\n                width: 350px;\n                transition: width 0.3s;\n            }\n\n            .main {\n                width: calc(100vw - 350px);\n                height: 100vh;\n                overflow-y: auto;\n                margin-top: 0px;\n            }\n\n            .custom_header {\n                display: flex;\n\n                img {\n                    display: none;\n                    visibility: collapse;\n                }\n\n                &_avatar {\n                    img {\n                        display: block;\n                        visibility: visible;\n                    }\n                }\n            }\n        }\n\n        &__without_sidebar {\n            display: flex;\n\n            .sidebar {\n                width: 0;\n                transition: width 0.3s;\n                visibility: collapse;\n            }\n\n            .main {\n                width: 100vw;\n                height: 100vh;\n                overflow-y: auto;\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
